module.exports = __webpack_public_path__ + "img/q3.b7a18925.png";